"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectType = (value) => value.schemaComposer.isObjectType(value);
exports.default = (composer) => {
    composer.forEach(value => {
        if (exports.isObjectType(value)) {
            value.addFields({
                id: "VLText!",
                isAccessRestricted: "Boolean!",
            });
        }
    });
    return composer;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkQ29udGVudEZpZWxkcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jbXMvc2NoZW1hL2J1aWxkZXJzL2FkZENvbnRlbnRGaWVsZHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFNYSxRQUFBLFlBQVksR0FBRyxDQUMxQixLQUE2QixFQUNBLEVBQUUsQ0FBQyxLQUFLLENBQUMsY0FBYyxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUUzRSxrQkFBZSxDQUFDLFFBQTZCLEVBQUUsRUFBRTtJQUMvQyxRQUFRLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFO1FBQ3ZCLElBQUksb0JBQVksQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUN2QixLQUFLLENBQUMsU0FBUyxDQUFDO2dCQUNkLEVBQUUsRUFBRSxTQUFTO2dCQUNiLGtCQUFrQixFQUFFLFVBQVU7YUFDL0IsQ0FBQyxDQUFDO1NBQ0o7SUFDSCxDQUFDLENBQUMsQ0FBQztJQUNILE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUMsQ0FBQyJ9